

























































import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  computed: {
    ...mapState({
      clientId(state: IState) {
        return this.$_.get(state, "user.id", "");
      }
    })
  },
  components: {
    "cprods-provider": () =>
      import("@/components/app/global/contractProducts/cProdsProvider.vue"),
    "cprod-with-fields-grid-item": () =>
      import(
        "@/components/app/global/contractProducts/cProdWithFieldsGridItem.vue"
      )
  }
})
export default class ContractProductsNeedsConfirmation extends Vue {
  // Map state

  public clientId!: IClient["id"];

  // Data

  public manualFilters = {
    "filter[provision_setup_fields_confirmed]": false,
    exclude_delegated: 1
  };

  public progress = 0;
  public showAllProducts = false;

  // Methods

  public mounted() {
    setTimeout(() => {
      this.progress = 66;
    }, 1000);
  }
}
